
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"90","height":"90","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M43.189 19.734C40.243 9.845 29.839 4.216 19.95 7.161 10.061 10.106 4.432 20.511 7.377 30.4l3.899-1.161c-2.304-7.736 2.1-15.875 9.835-18.179 7.736-2.304 15.875 2.1 18.179 9.835l3.899-1.16z"}},[_c('animateTransform',{attrs:{"attributeType":"xml","attributeName":"transform","type":"rotate","from":"0 25 25","to":"360 25 25","dur":"0.6s","repeatCount":"indefinite"}})])])
          )
        }
      }
    